import React, { useContext } from 'react';
import asyncComponent from './AsyncFunc';
import { Spin } from 'antd';
// import { Switch, Route, Redirect } from 'react-router';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
// import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import Template from '../Containers/Template/template';
import { Offline, Online } from "react-detect-offline";
import OfflineScreen from '../Containers/OfflineScreen/index';
// import OfflineScreen from './containers/Page/OfflineScreen/408';
// import { AppContext } from '../Contexts/App/AppContext';

const RestrictedRoute = ({ component: Component, loggedIn, loading, ...rest }) => (
    <Route
        {...rest}
        render={props => (loggedIn ? (
            // <Spin spinning={loading} delay={200}>
            <Template {...props}>
                <Component {...props} />
            </Template>
            // </Spin>
        ) : (
                <Spin spinning={loading} delay={200}>
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: props.location },
                        }}
                    />
                </Spin>
            ))}
    />
);
const SignUpRoutes = ({ component: Component, loggedIn, loading, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => (loggedIn === false ? (
                <Spin spinning={loading} delay={200}>
                    <Component {...props} />
                </Spin>
            ) : (
                    <Spin spinning={loading} delay={200}>
                        <Redirect
                            to={{
                                pathname: '/',
                                state: { from: props.location },
                            }}
                        />
                    </Spin>
                ))}
        />
    )
}
const PublicRoutes = ({ appCtx }) => (
    <Router>
        <>
            <Offline>
                <OfflineScreen />
            </Offline>
            <Online>
                <Switch>
                    {/* <RestrictedRoute   
            exact
            path={'/'}
            component={asyncComponent(() => import('./containers/Page/Dashboard/dashboard'))}
          /> */}
                    <RestrictedRoute
                        exact
                        path="/"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Project Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    <RestrictedRoute
                        exact
                        path="/addorder/:projectId"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Project Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    {/* <RestrictedRoute
                        exact
                        path="/parkinglot"
                        loggedIn={appCtx.login}
                        view="Project Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    /> */}

                    <RestrictedRoute
                        exact
                        path="/parkinglot/:locationId"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Project Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    <RestrictedRoute
                        exact
                        path="/returns"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Return Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    <RestrictedRoute
                        exact
                        path="/settings"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Settings"
                        component={asyncComponent(() => import('../Containers/Settings/index'))}
                    />

                    <RestrictedRoute
                        exact
                        path="/searchedRecords"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Searched Records"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    <RestrictedRoute
                        exact
                        path="/parkinglotdetail/:parkingLotId"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Project Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    <RestrictedRoute
                        exact
                        path="/itemdetails/:lineItemId"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Project Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    <RestrictedRoute
                        exact
                        path="/itemdetails"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        view="Project Detail"
                        component={asyncComponent(() => import('../Containers/DetailViews/index'))}
                    />

                    <SignUpRoutes
                        exact
                        path="/login"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        component={asyncComponent(() => import('../Containers/Login/index'))}
                    />

                    <SignUpRoutes
                        exact
                        path="/reset_password/:email"
                        loggedIn={appCtx.login}
                        loading={appCtx.loading}
                        component={asyncComponent(() => import('../Containers/Login/index'))}
                    />
                    {/* <Route path="/*" component={asyncComponent(() => import('./containers/Page/BlankPage/404'))} /> */}
                </Switch>
            </Online>
        </>
    </Router >
);

export default PublicRoutes;
